import { BoxGeometry, MeshBasicMaterial, Mesh, Matrix4, Vector3 } from 'three';
import Tooth from '../Model/Tooth';

const getSharedBoxGeometry = () => {
    if (!Tooth._sharedBoxGeometry) {
        Tooth._sharedBoxGeometry = new BoxGeometry(3.0, 4.0, 3.0);
        Tooth._sharedBoxGeometry.isShared = true;
    }
    return Tooth._sharedBoxGeometry;
};

export const computeToothMatrix = (tooth) => {
    const material = new MeshBasicMaterial({ color: 0x800080 });
    const cube = new Mesh(getSharedBoxGeometry(), material);

    tooth.matrixCalculatorObj = cube;
    tooth.refObj.add(cube);
    cube.visible = false;
    tooth.matrixCalculatorObj.updateMatrixWorld(true);
    tooth.saveOriginalState();
};

export const computeToothAxes = (tooth) => {
    const material = new MeshBasicMaterial({ color: 0x800080 });
    const cube = new Mesh(getSharedBoxGeometry(), material);

    tooth.axesCalculatorObj = cube;

    const rotationMatrix = new Matrix4();
    const xAxis = new Vector3().copy(tooth.vecRoot).normalize();
    const yAxis = new Vector3().copy(tooth.vecVestibularLingual).normalize();
    const zAxis = new Vector3().copy(tooth.vecRidge).normalize();

    rotationMatrix.makeBasis(xAxis, yAxis, zAxis);
    tooth.axesCalculatorObj.setRotationFromMatrix(rotationMatrix);

    tooth.refObj.add(cube);
    cube.visible = false;
    tooth.axesCalculatorObj.updateMatrixWorld(true);
};
